/**
 * Created by chachora on 11/23/18.
 */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import withStyles from '@mui/styles/withStyles';

import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { isMobileDevice } from '../../helpers/mobile';

class SlotDialog extends Component {
  state = {
    slotData: this.props.slotData,
  };

  clearSlotData() {
    this.setState({ slotData: '' });
  }

  handleChange = e => {
    this.setState({ slotData: e.target.value });
  };

  handleClose = () => {
    this.props.onClose();
    this.clearSlotData();
  };

  handleSubmit = () => {
    const { slotData } = this.state;
    this.props.onSubmit(slotData);
    this.props.onClose();
    this.clearSlotData();
  };

  render() {
    const { classes, t } = this.props;
    const { slotData } = this.state;
    const isSmallWidth = isMobileDevice();

    return (
      <>
        <DialogContent className={classes.content}>
          <TextField
            multiline
            rows="10"
            value={slotData}
            onChange={this.handleChange}
            className={classes.textField}
            inputProps={{ className: classes.textField }}
            margin="normal"
            helperText={
              !isSmallWidth
                ? '*You can also use Ctrl+V to open this dialog and paste the slot data'
                : null
            }
            variant="outlined"
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            {t('Cancel')}
          </Button>
          <Button onClick={this.handleSubmit} color="primary">
            {t('Add_to_schedule')}
          </Button>
        </DialogActions>
      </>
    );
  }
}

const styles = theme => ({
  content: {
    display: 'flex',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
  },
  textField: {
    flex: '1 0 0',
    marginRight: theme.spacing(),
  },
});

export default withTranslation()(withStyles(styles)(SlotDialog));
